import React from 'react'
import moment from "moment";
import PageHeader from "../../../../components/PageHeader";
import Sidebar from "../../../../components/Sidebar";
import {checkPermission} from "../../../../utils/common";
import Pagination from "../../../../components/Pagination";
import TableHeader from "../../../../components/TableHeader";
import AdSchoolInfoManager from "../../../../services/system/school-info/ad-school-info-manager";
import LinkPlus from "../../../../components/Link/LinkPlus";
import {createSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import {getSchoolId} from "../../../../utils/authority";
import ModalDeleteSchool from "./modalDeleteSchool";

class SchoolManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSchoolId: getSchoolId() >=0,
            page: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: 'created_at desc',
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showModalLock: false,
            showModalUnlock: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'name',
                    name: 'Tên trường',
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'code',
                    name: "Mã trường",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'headmasters',
                    name: "Hiệu trưởng",
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'address',
                    name: "Địa chỉ",
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'status',
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
        this.setState({showLoading: true}, () => {
            this.getListSchool()
        });
    }

    onSearch = () => {
        this.setState({showLoading: true}, () => {
            this.getListSchool()
        })
    };

    getListSchool = () => {
        let {pageNumber, pageSize, sort} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sort: sort,
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success) {
                this.setState({
                    listData: res.data.content,
                    totalItem: 10,
                    totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                    showLoading: false
                }, () =>{
                    window.scrollTo(0, 0)
                });
                localStorage.setItem("ListSchool", JSON.stringify(res.data.content))
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };

    handleChangePage = (page) => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListSchool()
            }
        );
    };

    renderStatus = (statusType) => {
        switch (statusType) {
            case "PENDING":
                return <h6><span className="badge badge-info">Đang duyệt</span></h6>;
            case "ACTIVE":
                return <h6><span className="badge badge-success">Đang hoạt động</span></h6>;
            case "DISABLE":
                return <h6><span className="badge badge-dark">Đã khóa</span></h6>;
            case "EXPIRED":
                return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
            case "DELETEs":
                return <h6><span className="badge badge-danger">Đã xóa</span></h6>;
            default:
                return '';
        }
    };

    render() {
        let {pageNumber, pageSize, accountBalance} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-school-management" parentClass="system-school-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} title="Danh sách trường học"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className='col-xs-12 col-sm-12 col-md-12 text-left pl-0 mt-3'>
                                                {checkPermission("SCHOOL_ADD") &&
                                                <LinkPlus
                                                    to="/ad-sas-school/them-truong-hoc"
                                                >
                                                    <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                                         style={{
                                                             alignItems: "center",
                                                             justifyContent: "right"
                                                         }}>
                                                        <button
                                                            style={{height: 35, marginRight: 12}}
                                                            type="button"
                                                            className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                        >
                                                            Thêm mới
                                                        </button>
                                                    </div>
                                                </LinkPlus>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-wrapper">
                                    <table className="table table-striped table-data table-bordered">
                                        <thead>
                                        <TableHeader header={this.state.header} clickSort={(data) => {
                                            let a = '';
                                            if (data.sortAsc == null) {
                                                a = ''
                                            } else {
                                                a = `id_sort=${data.sortAsc ? 'created_at asc' : 'created_at desc'}`;
                                            }
                                            this.setState({
                                                sort: a
                                            }, () => this.getListSchool())
                                        }}/>
                                        </thead>
                                        {!this.state.listData || this.state.listData.length == 0
                                            ? <tbody>
                                            <tr>
                                                <td colSpan={12}>
                                                    <div className='text-center'>Không có dữ liệu</div>
                                                </td>
                                            </tr>
                                            </tbody>
                                            : <tbody>
                                            {this.state.listData.map((row, index) => (
                                                <tr key={row.id} style={{height: 50}}>
                                                    <td style={{textAlign: 'center'}}>{pageNumber * pageSize + index + 1}</td>
                                                    <td style={{textAlign: 'left',}}>
                                                        {row.name}
                                                    </td>
                                                    <td style={{textAlign: 'left'}}>
                                                        {row.abbreviationName}
                                                    </td>
                                                    <td style={{textAlign: 'left'}}>
                                                        {row.principalRes?.fullName}
                                                    </td>
                                                    <td style={{textAlign: 'left'}}>
                                                        {row.address}
                                                    </td>
                                                    <td style={{textAlign: 'center'}}>
                                                        {this.renderStatus(row.status)}
                                                    </td>
                                                    <td className='p-1' style={{textAlign: 'center'}}>
                                                        {checkPermission("SCHOOL_EDIT") &&
                                                            <LinkPlus
                                                                style={{color: '#000'}}
                                                                to={{
                                                                    pathname: "/ad-sas-school/sua-truong-hoc",
                                                                    search: createSearchParams({
                                                                        id: `${row.id}`
                                                                    }).toString(),
                                                                    state: {
                                                                        fromDashboard: true,
                                                                        id: row.id
                                                                    }
                                                                }}
                                                            >
                                                                <button className="btn btn-action p-2"
                                                                        title='Xem chi tiết'
                                                                        style={{cursor: 'pointer'}}
                                                                >
                                                                    <i className="ti-pencil-alt"/>
                                                                </button>
                                                            </LinkPlus>
                                                        }
                                                        {/*{checkPermission("SCHOOL_DELETE") &&*/}
                                                        {/*    <button className="btn btn-action p-2"*/}
                                                        {/*            title='Xóa'*/}
                                                        {/*            style={{cursor: 'pointer'}}*/}
                                                        {/*            onClick={() => {*/}
                                                        {/*                this.setState({itemSelected: row.id, showModalDelete: true, name: row.role})*/}
                                                        {/*            }}*/}
                                                        {/*    >*/}
                                                        {/*        <i className="ti-trash"/>*/}
                                                        {/*    </button>*/}
                                                        {/*}*/}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>}
                                    </table>
                                </div>

                                <div className="pagination-right">
                                   <Pagination
                                        activePage={this.state.pageNumber}
                                        itemsCountPerPage={this.state.pageSize}
                                        totalItemsCount={this.state.totalItem}
                                        changeHandler={(page) => this.handleChangePage(page)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteSchool
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListSchool()}
                    id={this.state.itemSelected}
                    role={this.state.name}
                />
            </div>
        )
    }

}

export default SchoolManagement
